import React, { useState, useEffect } from 'react'
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri'
import './navbar.css'
import logo from '../../assets/images/lsk_white.png'

const Menu = () => (
    <>
          <p><a href='#home'>Home</a></p>
          <p><a href='#about'>Quem Somos</a></p>
          <p><a href='#solutions'>Nossas Soluções</a></p>
          <p><a href='#work'>Nosso Trabalho</a></p>
          <p><a href='#content'>Blog</a></p>
          <p><a href='#joinus'>Trabalhe Conosco</a></p>
    </>
)

const Navbar = () => {

  const [toggleMenu, setToggleMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {

      let teste = document.querySelectorAll(".lsk__navbar-links_container p");

      if (window.scrollY > 20) {
        document.querySelector(".img__logo").className = "img__logo img__logo-scroll";
        document.querySelector(".lsk__navbar-links_container").className = "lsk__navbar-links_container lsk__navbar-links_container-scroll"
        document.querySelector(".lsk__navbar").className = "lsk__navbar lsk__navbar-scroll";
        teste.forEach((item) => {
          item.className="lsk__navbar-links_container lsk__navbar-links_container-scroll"
        })
    
      } else {
        document.querySelector(".img__logo").className = "img__logo";
        document.querySelector(".lsk__navbar").className = "lsk__navbar";
        teste.forEach((item) => {
          item.className="lsk__navbar-links_container"
        })
      }
    }
    window.addEventListener('scroll', handleScroll);
  })

  return (
    <div className='lsk__navbar-principal'>
    <div className='lsk__navbar' id='controle'>
      <div className='lsk__navbar-links'>
        <div className='lsk__navbar-links_logo'>
          <img src={logo} alt='logo' className='img__logo'></img>
        </div>  
        <div className='lsk__navbar-links_container'>
         <Menu />
        </div>
        <div className='lsk__navbar-sign'>
          <button type='button'>Vamos Começar </button>
        </div>
        <div className='lsk__navbar-menu'>
          {toggleMenu 
            ? <RiCloseLine color='#000000' size={27} onClick={() => setToggleMenu(false)} />
            : <RiMenu3Line color='#000000' size={27} onClick={() => setToggleMenu(true)} />}
          {toggleMenu && (
              <div className='lsk__navbar-menu_container scale-up-center'>
                <div className='lsk__navbar-menu_container-links'>
                  <Menu />
                </div>
                <div className='lsk__navbar-menu_container-links-sign'>
                  <p>Sign in</p>
                  <button type='button'>Sign up </button>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
    </div>
  )
}

export default Navbar